import { IOBuffer } from 'iobuffer';
import { readBlock } from './readBlock';
import { readFileHeader } from './readFileHeader';
import { isCorrupted } from './utilities';
/**
 * Parses a .wdf Raman file and outputs all the parsed information
 *
 * @param data WDF file buffer
 * @return JSON Object containing all the parsed information from the WDF file
 */
export function parse(data) {
    const buffer = new IOBuffer(data);
    const fileHeader = readFileHeader(buffer);
    let blocks = [];
    let blockHeaderTypes = [];
    while (buffer.length > buffer.offset) {
        const block = readBlock(buffer, fileHeader);
        blocks.push(block);
        blockHeaderTypes.push(block.blockType);
    }
    /* check if the block headers are complete */
    isCorrupted(blockHeaderTypes, fileHeader.type);
    return { fileHeader, blocks };
}
//# sourceMappingURL=parse.js.map